import { GET_DATA, GET_MENU, SEARCH_MENU, FILTER_ITEMS, SPL_CAT, GET_MERCHANT } from "../actionTypes";
import { createSelector } from 'reselect'
import { merchantId } from "../../common/Functions";

const initialState = {
    merchant_id: merchantId,
    details: false,
    menu: [],
    original_menu: [],
    searchString: "",
    selectedFilter: 0,
    specialCategory: {},
    isLoaded: false,
    specialCategoryAll: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SPL_CAT: {
            return {
                ...state,
                specialCategory: action.payload
            }
        }
        case GET_DATA: {
            return {
                ...state,
                details: action.payload

            }
        }
        case GET_MENU: {
            return {
                ...state,
                menu: action.payload.menu,
                original_menu: action.payload.menu,
                isLoaded: true,
                specialCategoryAll: action.payload.splcategory

            }
        }
        case FILTER_ITEMS:
        case SEARCH_MENU: {
            console.log({
                ...state,
                menu: action.payload.new_menu,
                searchString: action.payload.searchString

            })
            return {
                ...state,
                menu: action.payload.new_menu,
                searchString: action.payload.searchString

            }
        }


        default:
            return state;
    }
}

const getSpecialCatsFactory = (state, item_id) => {
    return state.restaurant.specialCategoryAll.filter(catItems => catItems.items.indexOf(item_id) !== -1).map(catItems => catItems.cat_id)

}
export const getSpecialCats = createSelector(getSpecialCatsFactory, categories => categories);


export const getItemCategoryNonSelector = (state, item_id) => {
    let categoryNames = "";
    state.restaurant.original_menu.forEach(category => {
        if (category.items.some(item => item.item_id == item_id)) {
            categoryNames = category.category_name;
        }

        if (category.child_cat) {
            category.child_cat.forEach(childCat => {
                if (childCat.items.some(item => item.item_id == item_id)) {
                    categoryNames = category.category_name + ", " + childCat.category_name;
                }
            })
        }
    });
    return categoryNames;
}

export const getItemCategory = createSelector(getItemCategoryNonSelector, categoryNames => categoryNames);


const items = state => state.restaurant.original_menu

export const getItemTag = (state, item_id) => {

    let tagIds = "";
    if (state.restaurant.original_menu) {
        state.restaurant.original_menu.forEach(category => {
            category.items.forEach(item => {
                if (item.item_id == item_id) {
                    tagIds = item.dish_new;
                    if (tagIds.indexOf("1")) return "veg";
                    if (tagIds.indexOf("2")) return "non-veg";
                    return;
                }
            })
            if (category.child_cat) {
                category.child_cat.foreach(childCat => {
                    childCat.items.forEach(item => {
                        if (item.item_id == item_id) {
                            tagIds = item.dish_new;
                            if (tagIds.indexOf("1")) return "veg";
                            if (tagIds.indexOf("2")) return "non-veg";
                            return;
                        }
                    })
                })
            }
        })
    }
    return tagIds;
}



const onlyItems = state => {
    const items = [];
    state.restaurant.original_menu.forEach(category => {
        category.items.forEach(item => {
            items.push(item);
        })

        if (category.child_cat) {
            category.child_cat.forEach(childCat => {
                childCat.items.forEach(item => {
                    items.push(item);
                })
            })
        }

    });
    return items;
}


export const getAvailableTags = createSelector(onlyItems, items => {
    const data = [];
    items.forEach(item => {
        item.dish_new.forEach(dish => {
            data.push(dish);
        });
    });
    return [...new Set(data)]
});






